import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { Ref } from "vue";

export const authKeys = createQueryKeys("auth", {
  sso: (email: Ref<string | undefined>) => [{ email }],
  regionConfig: (email: Ref<string | undefined>) => [{ email }],
});
